import {
  buttonVariants,
  ClickToCopy,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@bleu.builders/ui";
import { MailIcon } from "lucide-react";
import React from "react";

const SUPPORT_EMAIL = "contato@clickfiscal.com.br";

export enum TemplateMessage {
  DOUBT = "DOUBT",
  OVERDUE_PAYMENT = "OVERDUE_PAYMENT",
  TRIAL_SUBSCRIBE = "TRIAL_SUBSCRIBE",
  THESIS_ERROR = "THESIS_ERROR",
  REUSABLE_DIAGNOSIS_LINK_CREATION = "SHARED_LINK_DIAGNOSIS_CREATION",
  CREDITS_PURCHASE = "CREDITS_PURCHASE",
}

const fallbackTemplateMessageMap = {
  [TemplateMessage.DOUBT]: `Olá, tudo bem? {{name_email}}Sou assinante do ClickFiscal e gostaria de esclarecer uma dúvida.`,
  [TemplateMessage.OVERDUE_PAYMENT]: `Olá, tudo bem? {{name_email}}Gostaria de saber mais sobre o pagamento da minha assinatura.`,
  [TemplateMessage.TRIAL_SUBSCRIBE]: `Olá, tudo bem? {{name_email}}Estou no período de teste e gostaria de assinar a plataforma.`,
  [TemplateMessage.THESIS_ERROR]: `Olá, tudo bem? {{name_email}}Tive um erro ao adquirir uma tese.`,
  [TemplateMessage.REUSABLE_DIAGNOSIS_LINK_CREATION]: `Olá, tudo bem? {{name_email}}Gostaria de saber mais sobre o diagnóstico tributário compartilhável.`,
  [TemplateMessage.CREDITS_PURCHASE]: `Olá, tudo bem? {{name_email}}Gostaria de saber mais sobre a compra de créditos.`,
};

const NAME_EMAIL_TEMPLATE = `Meu nome é {{firstName}} e meu e-mail é {{email}}. `;

const replaceParams = (template: string, params: Record<string, string>) => {
  return Object.entries(params).reduce(
    (acc, [key, value]) => acc.replace(`{{${key}}}`, value),
    template,
  );
};

export function DialogTemplatedMessage({
  children,
  template,
  firstName,
  email,
}: {
  children: React.ReactNode;
  template: TemplateMessage;
  firstName: string;
  email: string;
}) {
  const message = replaceParams(fallbackTemplateMessageMap[template], {
    name_email: replaceParams(NAME_EMAIL_TEMPLATE, { firstName, email }),
  });

  return <EmailModal message={message}>{children}</EmailModal>;
}

export function EmailModal({ message, children }) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader className="justify-start">
          <DialogTitle className="flex gap-2 items-center justify-start text-center">
            <span className="text-primary">Enviar E-mail para Suporte</span>
            <MailIcon className="text-primary size-5 font-bold" />
          </DialogTitle>
          <DialogDescription className="text-left">
            Por favor, copie a mensagem abaixo e envie manualmente para:{" "}
            <strong>{SUPPORT_EMAIL}</strong>
          </DialogDescription>
        </DialogHeader>
        <textarea
          readOnly
          rows={10}
          value={message}
          className="w-full mt-4 p-2 border rounded-md"
        />
        <DialogFooter className="flex gap-2 items-start mt-4">
          <ClickToCopy className={buttonVariants()} text={message}>
            Copiar Mensagem
          </ClickToCopy>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
